import React, { useEffect, useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faLinkedin,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import "./Menu.css";

const Menu = () => {
  const [displayMenu, setShowHideMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const onMenuClickHandle = useCallback((evt) => {
    setShowHideMenu(!displayMenu);
  }, [displayMenu]);

  useEffect(() => {
    return () => {
      const divs = document.querySelectorAll(".menu-item");
      divs.forEach((item) => {
        let word = item.children[0].children[0].innerText.split("");
        item.children[0].children[0].innerHTML = "";

        word.forEach((letter, idx) => {
          item.children[0].children[0].innerHTML += `<span style="--index: ${
            idx * 3
          };">${letter}</span>`;
        });

        let cloneDiv = item.children[0].cloneNode(true);
        cloneDiv.style.position = "absolute";
        cloneDiv.style.left = -100;
        cloneDiv.style.top = -100;
        item.appendChild(cloneDiv);
      });

      let item = document.querySelector(".menu-btn-effect");
      let word = item.children[0].innerText.split("");
      item.children[0].innerHTML = "";
      word.forEach((letter, idx) => {
        item.children[0].innerHTML += `<span style="--index: ${
          5 + idx * 5
        };">${letter}</span>`;
      });
    };
  }, []);


  const scrollToSection = useCallback((id) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -70; // Adjust the offset as needed (to compensate for fixed navbar height)
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    onMenuClickHandle();
  }, [onMenuClickHandle]);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Handle scroll detection for navbar background
  const handleScroll = useCallback(() => {
    const scrollTop = window.scrollY;
    setIsScrolled(scrollTop > 50); // Show background after 50px scroll
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <div>
      {/* Navigation background bar */}
      <div className={`nav-background ${isScrolled ? 'scrolled' : ''}`}></div>
      
      <button
        type="button"
        onClick={scrollToTop}
        className={`site-name ${displayMenu ? "" : "menu-displayed"} ${isScrolled ? 'scrolled' : ''}`}
        aria-label="Go to top of page"
      >
        <div className="site-name-part1">Code</div>
        <div className="site-name-part2">Uniquely</div>
      </button>
      <button
        className={`menu-btn ${displayMenu ? "" : "menu-displayed"} ${isScrolled ? 'scrolled' : ''}`}
        onClick={onMenuClickHandle}
        aria-label="Toggle navigation menu"
        aria-expanded={displayMenu}
      >
        <div>M</div>
        <div className="menu-btn-effect">
          <span className="stroke">ENU</span>
        </div>
      </button>

      <nav className={`menu ${displayMenu ? "" : "hide-menu"}`} role="navigation" aria-label="Main navigation">
        <div className="menu_container">
          <a href="#projects" onClick={() => scrollToSection('projects')} className="menu-item" style={{ "--number": "6" }}>
            <div className="nav-txt-wrap">
              <div className="nav-90-div">
                <span className="menu-item-text">WORK</span>
              </div>
            </div>
          </a>
          <div className="nav-divider is-1st" style={{ "--number": "6" }}></div>
          <a href="#about-me" onClick={() => scrollToSection('about-me')} className="menu-item" style={{ "--number": "4" }}>
            <div className="nav-txt-wrap">
              <div className="nav-90-div">
                <span className="menu-item-text">ABOUT</span>
              </div>
            </div>
          </a>
          <div className="nav-divider is-1st" style={{ "--number": "4" }}></div>
          <a href="#contact" onClick={() => scrollToSection('contact')} className="menu-item" style={{ "--number": "2" }}>
            <div className="nav-txt-wrap">
              <div className="nav-90-div">
                <span className="menu-item-text">CONTACT</span>
              </div>
            </div>
          </a>
          <div className="nav-divider is-1st" style={{ "--number": "2" }}></div>
          <div className="my-details-section">
            <div className="details-container">
              <div className="mobile">
                <a href="tel:+919552540363" className="txt-link">
                  +91 95525 40363
                </a>
              </div>
              <div className="email">
                <a
                  href="mailto:anand.sonu@gmail.com?subject=Hey Sunil!"
                  className="txt-link"
                >
                  anand.sonu@gmail.com
                </a>
              </div>
              <div className="social-details">
                <div className="social-icons">
                  <a
                    href="https://twitter.com/anand_sunil"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tilt-box-wrap"
                  >
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="tilt-box">
                      <strong>
                        <FontAwesomeIcon icon={faTwitter} />
                      </strong>
                    </div>
                  </a>

                  <a
                    href="https://www.linkedin.com/in/sunil-anand-ba19544/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tilt-box-wrap"
                  >
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="tilt-box">
                      <strong>
                        <FontAwesomeIcon icon={faLinkedin} />
                      </strong>
                    </div>
                  </a>
                  <a
                    href="https://github.com/sunilanand"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tilt-box-wrap"
                  >
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="t_over"></div>
                    <div className="tilt-box">
                      <strong>
                        <FontAwesomeIcon icon={faGithub} />
                      </strong>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="menu-bottom-img"></div>
      </nav>
    </div>
  );
};

export default Menu;
